import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import FileDropZone from "../utilities/FileDropZone";
import { useDropzone } from "react-dropzone";
import Icon from "@mdi/react";
import {
    mdiChevronDown,
    mdiChevronRight,
    mdiCircle,
    mdiCircleOutline,
    mdiCloseCircleOutline,
    mdiTrashCanOutline,
} from "@mdi/js";
import Styles from "./ParametersStamp.scss";
import { LOGO_MARIANE_IMG, UE_SVG_LOGO, UE_LOGO } from "../../../constants";

const ParametersStamp = ({ entity, updateStructureInfo }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, errors, reset } = useForm({});
    const [files, setFiles] = useState([]);
    const [currentSection, setCurrentSection] = useState();
    const [trackedInput, setTrackedInput] = useState("logo");
    const [stamp, setStamp] = useState();
    const [logo, setLogo] = useState();

    /*const {getRootProps, getInputProps, isDragReject} = useDropzone({
        accept: {
            'image/!*': [],
        },
        'minSize': 1,
        'maxSize': 2048000,
        onDrop: acceptedFiles => {
             acceptedFiles.map(async file => {
                 let formData = new FormData();
                 formData.append(trackedInput, file );
                 formData.append('_method','PUT');
                 try {
                     const response = await axios.post("/Api/user/entity", formData);
                     console.log(response);
                     if(response?.data?.result){
                         updateStructureInfo({...entity, [trackedInput]: response.data.result});
                         (trackedInput==='logo')?setLogo(response.data.result):setStamp(response.data.result);
                         toast.success("les données ont bien été actialisées"  );
                     }else{
                         toast.error('Un problème c\'est produit et le fichier n\'à pas pu être actualisé'  );
                     }

                 } catch(error) {
                     console.log(error)
                 }
            });
        },
        onDropRejected: ()=>{
            toast.error('Le fichier transféré ne semble pas correspondre aux critères demandés !' );
        },
        onDragEnter: (e)=>{
            console.log(e)
        }
    });*/

    useEffect(() => {
        entity?.logo
            ? setLogo(
                  "storage/images/entities/" + entity.id + "/" + entity.logo
              )
            : null;
    }, []);

    useEffect(() => {}, [logo, stamp]);

    useEffect(() => {
        entity?.stamp ? setStamp(entity.stamp) : null;
        entity?.logo ? setLogo(entity.logo) : null;
    }, [entity]);
    /*
    const thumbs = files.map(file => (
        <div className={"ue-stamp-thumb"} key={file.name}>
            <div className={"thumbInner"}>
                <img
                    src={file.preview}
                    className={"ue-stamp-img"}
                    // Revoke data uri after image is loaded
                    onLoad={() => { URL.revokeObjectURL(file.preview) }}
                />
            </div>
        </div>
    ));*/

    const clearImage = async (ref) => {
        const response = await axios.post("/Api/user/entity/logo_stamp", {
            ref: ref,
            _method: "DELETE",
        });
        try {
            if (response?.data?.result) {
                ref === "logo"
                    ? updateStructureInfo({ ...entity, logo: null })
                    : updateStructureInfo({ ...entity, stamp: null });
                ref === "logo" ? setLogo(null) : setStamp(null);
                toast.success("Vos données ont bien été actualisée");
            } else {
                toast.error(
                    "Un problème s'est produit et vos données n'ont pas été actualisées !"
                );
            }
        } catch (e) {
            toast.error(
                "Un problème s'est produit et vos données n'ont pas été actualisées !"
            );
        }
    };

    const onChangeImageHandler = async (e) => {
        setTrackedInput("logo");
        let file = e.target.files[0];
        if (
            file.type !== "image/png" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/gif"
        ) {
            toast.error(
                "Votre fichier ne respect pas le format obligatoire (jpeg, png ou gif) !"
            );
        } else if (file.size >= 1700000) {
            toast.error(
                "Votre fichier ne respect pas le poid maximal autorisé de 1,7 mega par fichier !"
            );
        } else {
            await handleSubmission(file);
        }
    };

    const handleSubmission = async (file) => {
        let formData = new FormData();
        formData.append("logo", file);
        formData.append("_method", "PUT");
        try {
            const response = await axios.post("/Api/user/entity", formData);
            if (response?.data?.result) {
                console.log(response);
                updateStructureInfo({
                    ...entity,
                    [trackedInput]: response.data.result,
                });
                trackedInput === "logo"
                    ? setLogo(response.data.result)
                    : setStamp(response.data.result);
                toast.success("les données ont bien été actialisées");
            } else {
                toast.error(
                    "Un problème s'est produit et le fichier n'à pas pu être actualisé."
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className={"d-flex flex-column justify-content-center"}>
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="ue-zone-img-logo">
                    <img
                        id={"entity_default_logo_img"}
                        src={
                            !logo || logo === "null"
                                ? LOGO_MARIANE_IMG
                                : "storage/images/entities/" +
                                  entity.id +
                                  "/" +
                                  entity.logo
                        }
                        alt={
                            !logo || logo === "null"
                                ? "logo_mariane"
                                : "logo_structure"
                        }
                    />
                </div>
                {logo}
                <div>
                    {!logo || logo === "" || logo === "null" ? (
                        <form id={"logo_form"} encType={"multipart/form-data"}>
                            <input
                                className={"ue-input-file-hidden"}
                                type={"file"}
                                name={"logo_data"}
                                id={"logo_data"}
                                accept="image/gif, image/png, image/jpeg , application/pdf"
                                onChange={onChangeImageHandler}
                            />
                            <label
                                className={
                                    "ue-input-file-label btn btn-sm btn-outline-primary my-2"
                                }
                                htmlFor="logo_data"
                            >
                                Importer
                            </label>
                        </form>
                    ) : (
                        <div
                            className={
                                "ue-input-file-label btn btn-sm btn-outline-primary my-2"
                            }
                            onClick={() => clearImage("logo")}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-trash"
                                viewBox="0 0 16 16"
                            >
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                <path
                                    fillRule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                />
                            </svg>
                        </div>
                    )}
                </div>
            </div>
        </div>
        /*
        <div className={"row w-100"}>

            <div className={"col"}>
                <div className="ue-annexes_btn"
                     data-toggle="collapse"
                     data-target="#logo_toggle"
                     aria-expanded="false"
                     aria-controls="logo_toggle"
                     onClick={(e)=>setCurrentSection((currentSection)?'logo_toggle':null)}
                >

                </div>
                <div className="collapse" id="logo_toggle">
                    <div className={"d-flex flex-row w-100 justify-content-center align-items-center"}>
                        <div className="d-flex flex-column justify-content-center align-items-center mr-2">
                            <div className={""}>

                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <Icon path={(!logo)?mdiCircle:mdiCircleOutline} size={0.7} color={(!logo)?'var(--theme-primary)':'#CCC'} />
                                        <div className="ml-2" >Par defaut</div>
                                </div>
                            </div>
                            {
                                (1+1===2) ?
                                    <>
                                        <div className="ue-zone-img-logo" >
                                            <img id={'entity_default_logo_img'}
                                                 src={LOGO_MARIANE_IMG}
                                                 alt="logo_mariane"/>
                                        </div>
                                        <div style={{"height": "20px"}}></div>
                                    </>
                                    :null
                            }
                        </div>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className={""}>
                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <Icon path={(logo)?mdiCircle:mdiCircleOutline} size={0.8} color={(logo)?'var(--theme-primary)':'#CCC'} />
                                    <div className="ml-2" >Mon logo</div>
                                </div>
                            </div>
                            {
                                (logo && logo !== '')?
                                    <>
                                        <div className="ue-zone-img-logo" >
                                            <img id={'entity_logo_img'}
                                                 src={"storage/images/entities/" + entity.id + "/" + entity.logo}
                                                 alt="stamp"/>
                                        </div>
                                        <div className={"ue-btn-simple-outline-primary-sm"}
                                             onClick={(e) => clearImage('logo')}
                                        >
                                            <Icon path={mdiTrashCanOutline} size={0.75}/>
                                        </div>
                                    </>
                                    :  <form id={"logo_form"}   encType={"multipart/form-data"}>
                                                <section className="ue-stamp-container">
                                                        <div {...getRootProps({className: 'dropzone'})} onMouseEnter={(e)=>setTrackedInput("logo")}>
                                                            <input {...getInputProps()}  type={"file"} name={"logo_data"} id={"logo_data"}/>
                                                        <p>Cliquez ou collez un fichier image ici (max 2Meg)</p>
                                                    </div>
                                                <div style={{"height": "20px"}}></div>
                                                </section>
                                                <button type={"submit"} id={"ue_logo_submit"} style={{"display":"none"}} />
                                    </form>
                            }
                        </div>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center w-100 mt-3">
                        <div className={" "}>Mon tampon</div>
                            {
                                (stamp && stamp !== '') ?
                                    <>
                                    <div className="ue-zone-img-logo" >
                                        <img id={'entity_stamp_img'}
                                             src={"storage/images/entities/" + entity.id + "/" + entity.stamp}
                                             alt="stamp"/>
                                    </div>
                                       <div className={"ue-btn-simple-outline-primary-sm"}
                                               onClick={(e)=>clearImage('stamp')}
                                       >
                                           <Icon path={mdiTrashCanOutline} size={0.75}/>
                                       </div>
                                    </>
                                    : <section className="ue-stamp-container">
                                        <div {...getRootProps({className: 'dropzone'})} onMouseEnter={(e)=>setTrackedInput("stamp")}>
                                            <input {...getInputProps()} />
                                            <p>Cliquez ou collez un fichier image ici (max 2Meg)</p>
                                        </div>
                                        {/!*
                                        <aside className={"ue-stamp-thumbsContainer"}>
                                            {thumbs}
                                        </aside>
                                        *!/}
                                    </section>
                            }
                    </div>
                </div>
        </div>
     </div>*/
    );
};

const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        username: state.MeReducer.username,
        role: state.MeReducer.role,
        uiTheme: state.AppReducer.ui_theme,
        userPrefs: state.MeReducer?.prefs,
        structureInfo: state.SubscribtionReducer.structureInfo,
        entity: state.MeReducer.entity,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        updateUserInfo: (e) =>
            dispatch({ type: "UPDATE_USER_STATUS", data: e }),
        updateStructureInfo: (e) =>
            dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(ParametersStamp);
